module.exports = __webpack_public_path__ + "img/gscp.c00a315e.png";